import { Config } from 'next-i18n-router/dist/types'

const i18nConfig: Config = {
  locales: ['en', 'ar', 'de'],
  defaultLocale: 'en',
  prefixDefault: false,
}

export default i18nConfig
